import React, { useState } from "react";

// third-party
import { Modal, Row, Col } from "react-bootstrap";
import { FaCopy, FaEnvelope, FaFacebook, FaFacebookMessenger, FaLinkedin, FaTelegram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoCheckmarkCircle, IoLogoWhatsapp } from "react-icons/io5";

// project-imports
import { copy_to_clipboard, getOrCreateGuestId, toUpperSnake } from "../../utils";
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";
import { useSelector } from "react-redux";

export default function SharingModal({ show, onCloseModal, title = "", url }) {
    // Extracting methods and variables form the context
    const { loginData } = useSelector((item) => item?.user);

    // State initialization
    const [copied, setCopied] = useState(false);

    // Variables to get userId
    const member = (loginData && loginData?.data) || null;
    const currentUserId = member ? member?.userRecordId || "" : getOrCreateGuestId();

    // Format the text and URL for safe use in URLs
    const SharingTitle = encodeURIComponent(title);
    const shareUrl = encodeURIComponent(url);

    // Construct standard share intent links
    const shareLinks = {
        whatsapp: `https://wa.me/?text=${shareUrl}`,
        twitter: `https://twitter.com/intent/tweet?url=${shareUrl}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
        telegram: `https://t.me/share/url?url=${shareUrl}`,
        messenger: `https://www.facebook.com/dialog/send?link=${shareUrl}&app_id=YOUR_APP_ID&redirect_uri=${shareUrl}`,
        email: `mailto:?subject=${SharingTitle}&body=Check%20out%20this%20blog:%20${shareUrl}`,
    };

    // Social-Icons Items
    const socialItems = [
        {
            name: "WhatsApp",
            href: shareLinks.whatsapp,
            icon: <IoLogoWhatsapp size={34} color="#25D366" />,
            bg: "#EAFBF2",
        },
        {
            name: "Facebook",
            href: shareLinks.facebook,
            icon: <FaFacebook size={34} color="#1877F2" />,
            bg: "#EEF5FF",
        },
        {
            name: "X",
            href: shareLinks.twitter,
            icon: <FaXTwitter size={34} color="#000000" />,
            bg: "#F3F4F6",
        },
        {
            name: "Telegram",
            href: shareLinks.telegram,
            icon: <FaTelegram size={34} color="#229ED9" />,
            bg: "#EEF8FF",
        },
        {
            name: "LinkedIn",
            href: shareLinks.linkedin,
            icon: <FaLinkedin size={34} color="#0A66C2" />,
            bg: "#EEF6FF",
        },
        {
            name: "Messenger",
            href: shareLinks.messenger,
            icon: <FaFacebookMessenger size={34} color="#0084FF" />,
            bg: "#EEF5FF",
        },
        {
            name: "Email",
            href: shareLinks.email,
            icon: <FaEnvelope size={34} color="#EA4335" />,
            bg: "#FFF2F0",
        },
    ];

    const copyToClipboard = () => {
        try {
            copy_to_clipboard(url)
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.log("92: SharingModal : copyToClipboard", error);
        }
    };

    const handleShare = (item) => {
        try {
            triggerFunction(
                GoogleAnalyticsEnum.LINK,
                `Id_${currentUserId}_PLATFORM_${toUpperSnake(item?.name)}_URL_${url}`,
            )
        } catch (error) {
            console.log("103: SharingModal : handleShare", error);
        }
    }
    return (
        <>

            <Modal
                className="rounded-lg"
                show={show}
                onHide={onCloseModal}
                // size="xl"
                centered
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton className="px-5 pb-0 border-0">
                    <Modal.Title as={'h5'} className="mb-0" >Share</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row className="g-4 mt-2">

                        {(socialItems || [])?.map((item, index) => (
                            <Col xs={6} sm={4} md={3} lg={3} key={index}>

                                <a
                                    href={item?.href || "#"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-item"
                                    onClick={() => handleShare(item)}
                                >

                                    <div
                                        className={`share-icon`}
                                        style={{ backgroundColor: item?.bg }}
                                    >
                                        {item?.icon || ""}
                                    </div>

                                    <span className="share-title">
                                        {item?.name || ""}
                                    </span>

                                </a>

                            </Col>
                        ))}
                    </Row>
                    <div className="mt-2 p-20">
                        <label className="page-link-label">Page Link</label>

                        <div className="page-link-wrapper">

                            <input
                                type="text"
                                value={url || "#"}
                                readOnly
                                className="page-link-input"
                            />

                            <button
                                type="button"
                                className="copy-icon-btn"
                                onClick={copyToClipboard}
                            >
                                {copied ? <IoCheckmarkCircle size={20} /> : <FaCopy size={20} className="fa-copy-icon" />}
                            </button>

                        </div>
                    </div>
                </Modal.Body>

            </Modal>
        </>
    );
}